export const langEs = {
  html_title: 'AlcmeonChat',
  title: 'Sus asesores a distancia',
  subtitle: 'Respondemos a todas sus preguntas - ',
  privacy_link_prefix: 'Puede consultar nuestra política de privacidad',
  privacy_link_label: 'aquí',
  send_a_message: 'Enviar un mensaje...',
  send_your_email: 'Introduzca su dirección de correo electrónico...',
  send_your_phone: 'Envía tu número de teléfono, en formato +33612345678',
  select_an_option: 'Seleccione una opción',
  close_menu: 'Cerrar',
  'aria_label/close': 'cerrar',
  'aria_label/close-menu': 'cerrar',
  'aria_label/file-upload': 'cargar imagen o documento PDF',
  'aria_label/open_alcmeon_inmessage': 'abrir el chat',
  'aria_label/options': 'opciones',
  'aria_label/send_message': 'enviar el mensaje',
  'alt/an_image': 'una imagen',
  helperMessage1: `Hola 🙂<br/>¿Tienes alguna pregunta?`,
  helperMessage2: `Estamos aquí para ayudarle.`,
  helperMessage3: `<strong>Tienes una conversación en curso</strong>`,
  helperMessage4: `Continúa aquí 👉`,
  waitingMessage: `Un asesor le responderá en breve. Actualmente se encuentra en la posición {{position}}. Su tiempo de espera estimado es {{time}}, por favor espere.`,
  lessThan:'menos de',
  moreThan:'más de',
  minutes:'min'
};
